import { Button, Notification, STATUS_TYPES } from 'dyl-components';
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Dimmer, Grid, Header, Loader } from 'semantic-ui-react'
import paymentActions from "actions/payment";
import pbxConfigActions from "actions/pbx_config";
import { useParams } from 'react-router-dom';
import FullScreenModalPopUp from 'shared/FullScreenModalPopUp';
import PlatformAccountDetails from './PlatformAccountDetails';
import ForceHangUp from './ForceHangUp';
import PhoneSystem from './PhoneSystem';
import Extensions from './Extensions';
import provisionActions from 'actions/provision';

export default function Voip() {
    const dispatch = useDispatch();
    const { accountPbx, isReadingAccountPbx, extensionsList, isReadingExtensionsList, accountPbxServers, extensionInfo, isReadingExtensionsInfo } = useSelector((state) => state.pbx_config);
    const params = useParams()
    const [isConfirmationOpen, setIsConfirmationOpen] = useState({
        type: "",
        open: false
    })
    const [selectedExtension, setSelectedExtension] = useState(null);
    const account_id = Number(params.account_id);
    const domain_id = accountPbx?.domain_id;

    useEffect(() => {
        dispatch(paymentActions.getBalance(account_id, { isAdmin: true }));
        dispatch(pbxConfigActions.getListOfExtensions({ customer_id: account_id }))
        dispatch(pbxConfigActions.getAccountPbx(account_id));
        dispatch(pbxConfigActions.getAccountPbxServers(account_id));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch, account_id])

    useEffect(() => {
        if (domain_id && extensionsList?.length) {
            dispatch(pbxConfigActions.getExtensionInfo(domain_id, { extensions: extensionsList?.map((extension) => extension?.extension_number).join(",") }));
        }
    }, [domain_id, extensionsList, dispatch])

    const getPopuptitle = (type) => {
        if (type === "pbx") {
            return "All outbond calls will be halted on this account.";
        } else if (type === "resume_pbx") {
            return "All outbond calls will resume on this account.";
        } else if (type === "account_sip_passwords") {
            return "The SIP password will be changed for the account."
        } else if (type === "sip_password") {
            return `The SIP password will be changed for extension ${selectedExtension?.extension_number}.`
        } else if (type === "reset_device") {
            return `The device will be reset for extension ${selectedExtension?.extension_number}.`
        }
        return "";
    }

    const balanceInfo = useSelector(state => (state.payment.balanceInfo));
    const { isTogglingPause, isResettingPasswords } = useSelector(state => (state.pbx_config));
    const isUpdatingHardphone = useSelector(state => (state.provision.isUpdatingHardphone));
    const isApplyingChanges = isTogglingPause || isResettingPasswords || isUpdatingHardphone;
    return (
        <>
            <Grid>
                <Grid.Row columns='equal'>
                    <Grid.Column width={5}>
                        <Header color='primary'>Platform Account Details</Header>
                        <PlatformAccountDetails balanceInfo={balanceInfo} />
                    </Grid.Column>
                    <Grid.Column width={11}>
                        <Header color='primary'>Force Hang Up</Header>
                        <ForceHangUp domain={accountPbx} />
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column width={9}>
                        <Header color='primary'>Phone System (PBX)</Header>
                        <PhoneSystem domain={accountPbx} isLoading={isReadingAccountPbx} onPause={() => {
                            setIsConfirmationOpen({
                                type: accountPbx.outbound_paused ? "resume_pbx" : "pbx",
                                open: true
                            })
                        }} pbxConfigPbxServers={accountPbxServers} refresh={() => {dispatch(pbxConfigActions.getAccountPbx(account_id));}} />
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row columns='equal'>
                    <Grid.Column>
                        <Header color='primary'>Extensions
                            <Header floated='right'>
                                <Button onClick={() => {
                                    setIsConfirmationOpen({
                                        type: "account_sip_passwords",
                                        open: true
                                    })
                                }} primary disabled={!extensionInfo?.counts?.devices && !extensionInfo?.counts?.softphones}>Change Account SIP password</Button>
                            </Header>
                        </Header>
                        <Extensions 
                            extensions={extensionsList} 
                            extensionInfo={extensionInfo} 
                            isLoading={isReadingExtensionsList || isReadingExtensionsInfo} 
                            onChangeSip={(extension) => {
                                setSelectedExtension(extension);
                                setIsConfirmationOpen({
                                    type: "sip_password",
                                    open: true
                                })
                            }}
                            onResetDevice={(extension) => {
                                setSelectedExtension(extension)
                                setIsConfirmationOpen({
                                    type: "reset_device",
                                    open: true
                                })
                            }}
                        />
                    </Grid.Column>
                </Grid.Row>
                <FullScreenModalPopUp
                    header={"Are you sure?"}
                    subheader={getPopuptitle(isConfirmationOpen.type)}
                    isOpen={isConfirmationOpen.open}
                    onConfirm={async () => {
                        setIsConfirmationOpen({
                            type: "",
                            open: false
                        });
                        try {
                            if (isConfirmationOpen.type === "pbx" || isConfirmationOpen.type === "resume_pbx") {
                                await dispatch(pbxConfigActions.setPause(domain_id, { paused: ! accountPbx.outbound_paused }));
                                Notification.alert("Successfully updated PBX status!", STATUS_TYPES.SUCCESS);
                            } else if (isConfirmationOpen.type === "account_sip_passwords") {
                                await dispatch(pbxConfigActions.resetPasswords(domain_id));
                                Notification.alert("Successfully changed SIP password!", STATUS_TYPES.SUCCESS);
                            } else if (isConfirmationOpen.type === "sip_password") {
                                await dispatch(pbxConfigActions.resetPasswords(domain_id,{},{
                                    extension_id: selectedExtension.extension_number
                                }));
                                Notification.alert("Successfully changed SIP password!", STATUS_TYPES.SUCCESS);
                                setSelectedExtension(null);
                            } else if (isConfirmationOpen.type === "reset_device") {
                                await dispatch(provisionActions.resetDevice(domain_id, null, null, extensionInfo?.devices?.find(device => device?.extension === selectedExtension.extension_number)?.id || null));
                                Notification.alert("Successfully reset device associated with extension!", STATUS_TYPES.SUCCESS);
                                setSelectedExtension(null);
                            }
                            dispatch(pbxConfigActions.getAccountPbx(account_id));
                            dispatch(pbxConfigActions.getListOfExtensions({ customer_id: account_id }))
                            dispatch(pbxConfigActions.getExtensionInfo(domain_id, { extensions: extensionsList?.map((extension) => extension?.extension_number).join(",") }));
                        } catch (e) {
                            console.log(e);
                            Notification.alert(`An error occurred in ${(() => {
                                if (isConfirmationOpen.type === "account_sip_passwords") {
                                    return "changing SIP passwords for the account"
                                }
                                if (isConfirmationOpen.type === "sip_password") {
                                    return "changing SIP password"
                                }
                                if (isConfirmationOpen.type === "reset_device") {
                                    return "resetting device associated with extension"
                                }
                                if (isConfirmationOpen.type === "pbx") {
                                    return "updating PBX status"
                                }
                                return "performing this action."
                            })()}`, STATUS_TYPES.ERROR);
                        }
                    }}
                    onFormClose={() => setIsConfirmationOpen({
                        type: "",
                        open: false
                    })}
                    closeIcon={false}
                />
            </Grid>
            <Dimmer active={isApplyingChanges}>
                <Loader active={isApplyingChanges} />
            </Dimmer>
        </>
    )
}
